import React from "react"
import { DataTable } from "home/components/data_table"

export default class EnemExamSessionsTablePresentation extends React.Component {
  render () {
    return (
      <DataTable
        tableData={this.props.tableData}
        resource={this.props.resource}
        hasFilters={this.props.hasFilters}
        tableSize="big"
      />
    )
  }
}
